/** Type de tableaux de bord possible */
/** @todo FF : un enum commence à 1 ! merci de changer ça ! SL */
enum DashboardTypeEnum {
	/** Tableau de bord principal (MainDashboard) */
	Main = 0,
	/** Tableau de bord objet (ObjectDashboard) */
	Object = 1
};

export default DashboardTypeEnum;